module.exports = __webpack_public_path__ + "static/img/10019 (3).a5e08e7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (3).webp
// module id = jjf2
// module chunks = 14